// Vardiya QR Kodu Tasarla penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'shifts.qrPrint';

export const shiftQrPrintGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'Vardiya QR kodu nasıl tasarlanır?'),
  intro: t(`${G}.intro`, 'Personelin giriş-çıkış yaparken telefonla okutacağı QR kodu A5 sayfaya yerleştirip yazdırırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    list: t(`${G}.regions.list`, 'A5 tasarım alanı'),
    form: t(`${G}.regions.form`, 'Araçlar'),
    footer: t(`${G}.regions.footer`, 'Yazdır / Bilgisayara Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Vardiya sayfasında bir şube seçiliyse QR kod o şubeye, seçili değilse şirketinize aittir. Yazdırdığınız sayfayı personelin giriş-çıkışta okutacağı yere asarsınız.'),
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. QR türünü seçin'),
      text: t(`${G}.s2.text`, '"QR Türü" bölümünden seçin: "Tek QR" tek kod ile çalışır; giriş mi çıkış mı olduğu vardiya saatlerine göre otomatik belirlenir (tekli vardiyalar). Çift QR kullanan vardiyalarda "Giriş" ve "Çıkış" için ayrı ayrı sayfa hazırlayın; yön QR\'ın kendisinden alınır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Türü değiştirdiğinizde sayfadaki QR kod hemen yeni türe göre güncellenir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. QR, logo ve metin ekleyin'),
      text: t(`${G}.s3.text`, '"QR Ekle" QR kodu sayfaya koyar (sayfada en fazla bir QR olur). "Logo Ekle" ile bilgisayarınızdan PNG veya JPG resim seçin. "Metin Ekle" ile açıklama yazın; metin seçiliyken yazı tipi, boyut, hizalama, kalın/italik ve renk ayarlanır.'),
      tips: [
        t(`${G}.s3.tip1`, '"QR Kod Boyutu" ve "Logo Boyutu" kaydırıcıları seçili öğeye uygulanır; önce öğeye tıklayıp seçin.'),
        t(`${G}.s3.tip2`, '"Sayfa Yönlendirmesi" (Dikey/Yatay) ve "Arkaplan Rengi" de burada.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Öğeleri yerleştirin'),
      text: t(`${G}.s4.text`, 'Soldaki A5 sayfada öğeleri fareyle sürükleyerek taşıyın. Tıkladığınız öğe mavi çerçeveyle seçilir; kaldırmak için "Seçili Öğeyi Sil" düğmesine basın. Metin kutusunun genişliği seçiliyken sağ alt köşesinden değişir.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Yazdırın veya kaydedin'),
      text: t(`${G}.s5.text`, '"Yazdır" sayfayı A5 olarak yazdırma penceresinde açar; tarayıcı açılır pencereyi engellerse izin verin. "Bilgisayara Kaydet" sayfayı JPG resim olarak indirir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Pencereyi kapatınca tasarım bu şube (veya şirket) için saklanır ve sonraki açılışta geri gelir. Kayıt bu bilgisayardaki tarayıcıdadır; başka cihazda görünmez.'),
      ],
    },
  ],
});
